import React from 'react';

const HeadRow = () => {

    const cabeceras = ['Nombre', 'Apellido', 'Fecha de Nacimiento', 'e-mail', 'Tipo de Identificación', 'Valor de Identificación', 'Activo', 'Acción']

    return (
        <tr>
            {cabeceras.map((cabecera: string) => {
                return (<th key={cabecera}>{cabecera}</th>)
            })}
        </tr>
    );
};

export default HeadRow;